<template>
  <div class="GjMyReport">
      <div class="page-module">
        <el-menu :default-active="activeIndex" mode="horizontal" @select="handleSelect">
            <el-menu-item index="1">企业估值</el-menu-item>
            <el-menu-item index="2">股权激励</el-menu-item>
        </el-menu>
        
        <el-table :data="tableData" style="width: 100%" v-show="activeIndex == '1'" v-if="tableData.length > 0">
            <el-table-column prop="evuseagetype" label="估值用途" align="left" width="100px"> </el-table-column>
            <el-table-column prop="evindustrytype" label="所属行业" align="center" width="120px"> </el-table-column>
            <el-table-column prop="evphasetype" label="发展阶段" align="center"> </el-table-column>
            <el-table-column prop="modelname" label="估值模型" align="center"> </el-table-column>
            <el-table-column label="估值结果" align="center">
              <template slot-scope="scope">{{scope.row.evvalue}} 万元</template>
            </el-table-column>
            <el-table-column label="公司名称" align="center" width="200px">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.companyname" placement="top-start">
                  <!-- <el-button>上左</el-button> -->
                  <p class="companyname">{{scope.row.companyname}}</p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column prop="datetime" label="生成时间" align="center" width="170px"> </el-table-column>
            <el-table-column prop="date" label="操作" align="right">
                <template slot-scope="scope">
                  <el-button type="text" v-if="scope.row.isdownloadresult  == 0" @click="getPopu(scope.row.orderno)">获取报告</el-button>
                  <el-button type="text" v-if="scope.row.isdownloadresult  == 1" @click="downFile(scope.row.companyname, scope.row.fullfileurl, '1')">下载报告</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-table :data="tableData" style="width: 100%" v-show="activeIndex == '2'"  v-if="tableData.length > 0">
            <el-table-column label="公司名称" align="left" width="280px">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="scope.row.companyname" placement="top-start">
                  <p class="companyname">{{scope.row.companyname}}</p>
                </el-tooltip>
              </template>
            </el-table-column>
            <el-table-column label="注册资本" align="center">
              <template slot-scope="scope">{{scope.row.regcapital}} 万元</template>
            </el-table-column>
            <el-table-column prop="holdingtype" label="持股方式" align="center"> </el-table-column>
            <el-table-column prop="sharesource" label="股份来源" align="center"> </el-table-column>
            <el-table-column prop="datetime" label="生成时间" align="center" width="170px"> </el-table-column>
            <el-table-column prop="date" label="操作" align="right">
                <template slot-scope="scope">
                  <el-button type="text" @click="selectReport(scope.row.fullfileurl, scope.row.orderno, scope.row.isdownloadresult)">查看</el-button>
                  <span style="color: #ccc;margin: 0 5px">|</span>
                  <el-button type="text" v-if="scope.row.isdownloadresult == 0" @click="getJlPopu(scope.row.orderno, scope.row.companyname, api.page)">下载</el-button>
                  <el-button type="text" v-if="scope.row.isdownloadresult == 1" @click="getReportUrl(scope.row.companyname, scope.row.fullfileurl, '2', scope.row.orderno)">下载</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="null" v-if="tableData.length == 0">
          <img src="~@/common/images/gujing/null.png" alt="null">
          <p>当前暂无数据</p>
        </div>

        <el-pagination background layout="prev, pager, next" :total="rowCount" v-if="tableData.length > 0" :current-page.sync="api.page" @current-change="handleCurrentChange"></el-pagination>
      </div>
      <GetFreePopu ref="getFreePopu"></GetFreePopu>
      <GetJlPopu ref="getJlPopu" @getjustlist="getjustlist"></GetJlPopu>
  </div>
</template>

<script>
import $ from 'jquery'
import GetFreePopu from './components/getFreePopu.vue'
import GetJlPopu from './components/getJlPopu.vue'
import {mapActions, mapGetters} from 'vuex'
import {getAllEvListByUser, getAllSiListByUser, getReportUrl} from 'api/gujingApi'
export default {
  name: 'GjMyReport',
  data () {
    return {
        activeIndex: '1',
        tableData: [],
          api: {
            page: 1,
            pageSize: 10
          },
        rowCount: 0
    
    }
  },
  mounted () {
      $('html').scrollTop(0)
      $('html').css("background", '#f8f8f8')
      this.justList(1)
  },
  destroyed() {
    $('html').css("background", '#fff')
  },
  methods: {
      getPopu(orderno) {
        this.$refs.getFreePopu.startDialog(orderno, this.api.page)
      },
      handleSelect(val) {   // 切换
        this.activeIndex = val
        this.justList(1)
        // console.log(val)
      },
      handleCurrentChange(val) {  // 翻页
        this.justList(val)
      },
      // 判断调用列表
      justList(page) {
        if (this.activeIndex == '1') {
          this.getAllEvListByUser(page)
        } else {
          this.getAllSiListByUser(page)
        }
      },
      // 股权激励回调
      getjustlist() {
        this.justList(this.api.page)
      },
      // 股权激励弹窗
      getJlPopu(orderno, companyname) {
        this.$refs.getJlPopu.activePopu(orderno, companyname)
      },
      // 下载
      getReportUrl(companyname, fullfileurl, type, orderno) {
        this.setLoading(true)
            getReportUrl({
                  data: {orderno: orderno},
                  success: data => {
                      // console.log(data)
                      this.setLoading(false)
                      this.downFile(companyname, data.data.sireporturl, type)
                  },
                  error: data => {
                      this.$message.error(data.msg)
                  }
            })
      },
      // 企业估值
      getAllEvListByUser(page) {
        this.api.page = page

        this.setLoading(true)
        getAllEvListByUser({
          data: this.api,
          success: data => {
            this.setLoading(false)
            this.tableData = data.data.content
            this.rowCount = data.data.pageinfo.rowCount
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      // 股权激励
      getAllSiListByUser(page) {
        this.api.page = page
        this.setLoading(true)

        getAllSiListByUser({
          data: this.api,
          success: data => {
            this.setLoading(false)
            this.tableData = data.data.content
            this.rowCount = data.data.pageinfo.rowCount
          },
          error: data => {
            this.setLoading(false)
            this.$message.error(data.msg)
          }
        })
      },
      downFile(companyname, fullfileurl, type) { // 下载文件
        if (type == '1') {
          this.$refs.getFreePopu.downloadPdf(fullfileurl, companyname+'企业估值报告')
        } else {
          this.$refs.getFreePopu.downloadPdf(fullfileurl, companyname+'公司股权激励方案')
        }
      },
      // 查看报告
      selectReport(fullurl, orderno, isdownloadresult) {
        const {href} = this.$router.resolve({name: "SelectExcitation", query: {fullurl: fullurl, orderno: orderno, isdownloadresult: isdownloadresult}})
        window.open(href, '_blank')
      },
      ...mapActions(['setLoading','setUser', 'setLoginPop']),
      ...mapGetters(['user'])
  },
  filters: {},
  watch: {},
  computed: {},
  components: {
    GetFreePopu,
    GetJlPopu
  }
}
</script>

<style lang="scss" type="text/scss">
.GjMyReport {
    .page-module {
        margin-top: 100px;
        margin-bottom: 24px;
        background: #fff;
        text-align: center;

        .el-pagination {
            margin-top: 29px;
            margin-bottom: 30px;
        }
    }

    .el-table {
        thead {
            tr,th {
                background: #f8f8f8;
                font-size: 14px;
                color: #333;
                .cell {
                    font-weight:500;
                }
            }
        }
        .companyname {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
    }
    .null {
      text-align: center;
      img {
        margin: auto;
        margin-top: 100px;
        width: 129px;
        height: 77px;
      }
      p {
        margin-bottom: 400px;
        margin-top: 20px;
        font-size: 14px;
        color: #CADAEE;
      }
    }
    
}
  .el-tooltip__popper.is-dark {
      background: rgba(48,49,51,.8);
    }
    .el-tooltip__popper .popper__arrow, .el-tooltip__popper .popper__arrow::after {
      opacity: .8;
    }
</style>
